<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="2.62354" width="0.547039" height="9.77377" transform="rotate(-11.27 0 2.62354)" fill="url(#paint0_linear_1_1002)"/>
<rect x="0.537018" y="1.77283" width="0.547039" height="10.5032" transform="rotate(-11.27 0.537018 1.77283)" fill="url(#paint1_linear_1_1002)"/>
<rect x="1.43222" y="0.106934" width="0.547039" height="11.9619" transform="rotate(-11.27 1.43222 0.106934)" fill="url(#paint2_linear_1_1002)"/>
<rect x="2.3042" y="0.937134" width="0.547039" height="10.9773" transform="rotate(-11.27 2.3042 0.937134)" fill="url(#paint3_linear_1_1002)"/>
<rect x="3.86935" y="2.6333" width="0.547039" height="9.00791" transform="rotate(-11.27 3.86935 2.6333)" fill="url(#paint4_linear_1_1002)"/>
<rect x="4.48474" y="2.17615" width="0.547039" height="9.33613" transform="rotate(-11.27 4.48474 2.17615)" fill="url(#paint5_linear_1_1002)"/>
<rect x="2.04553" y="12.8883" width="1.23996" height="1.23996" transform="rotate(-11.27 2.04553 12.8883)" fill="url(#paint6_linear_1_1002)"/>
<rect x="2.42325" y="14.7841" width="1.23996" height="1.23996" transform="rotate(-11.27 2.42325 14.7841)" fill="url(#paint7_linear_1_1002)"/>
<rect x="3.90536" y="12.5177" width="1.23996" height="1.23996" transform="rotate(-11.27 3.90536 12.5177)" fill="url(#paint8_linear_1_1002)"/>
<rect x="4.28311" y="14.4132" width="1.23996" height="1.23996" transform="rotate(-11.27 4.28311 14.4132)" fill="url(#paint9_linear_1_1002)"/>
<rect x="5.76523" y="12.1471" width="1.23996" height="1.23996" transform="rotate(-11.27 5.76523 12.1471)" fill="url(#paint10_linear_1_1002)"/>
<rect x="6.14294" y="14.0426" width="1.23996" height="1.23996" transform="rotate(-11.27 6.14294 14.0426)" fill="url(#paint11_linear_1_1002)"/>
<rect x="7.62503" y="11.7765" width="5.47039" height="1.23996" transform="rotate(-11.27 7.62503 11.7765)" fill="url(#paint12_linear_1_1002)"/>
<rect x="8.00278" y="13.672" width="5.47039" height="1.23996" transform="rotate(-11.27 8.00278 13.672)" fill="url(#paint13_linear_1_1002)"/>
<defs>
<linearGradient id="paint0_linear_1_1002" x1="0.27352" y1="2.62354" x2="0.27352" y2="12.3973" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1652A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint1_linear_1_1002" x1="0.810537" y1="1.77283" x2="0.810537" y2="12.276" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1662A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint2_linear_1_1002" x1="1.70574" y1="0.106934" x2="1.70574" y2="12.0689" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1662A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint3_linear_1_1002" x1="2.57772" y1="0.937134" x2="2.57772" y2="11.9144" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1662A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint4_linear_1_1002" x1="4.14287" y1="2.6333" x2="4.14287" y2="11.6412" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1662A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint5_linear_1_1002" x1="4.75826" y1="2.17615" x2="4.75826" y2="11.5123" gradientUnits="userSpaceOnUse">
<stop stop-color="#F1662A"/>
<stop offset="1" stop-color="#F6B422"/>
</linearGradient>
<linearGradient id="paint6_linear_1_1002" x1="2.66551" y1="12.8883" x2="2.66551" y2="14.1283" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6BB21"/>
<stop offset="1" stop-color="#F6C320"/>
</linearGradient>
<linearGradient id="paint7_linear_1_1002" x1="3.04323" y1="14.7841" x2="3.04323" y2="16.024" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6C921"/>
<stop offset="1" stop-color="#F7D31F"/>
</linearGradient>
<linearGradient id="paint8_linear_1_1002" x1="4.52534" y1="12.5177" x2="4.52534" y2="13.7577" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6BB21"/>
<stop offset="1" stop-color="#F6C320"/>
</linearGradient>
<linearGradient id="paint9_linear_1_1002" x1="4.90309" y1="14.4132" x2="4.90309" y2="15.6532" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6C921"/>
<stop offset="1" stop-color="#F7D31F"/>
</linearGradient>
<linearGradient id="paint10_linear_1_1002" x1="6.38521" y1="12.1471" x2="6.38521" y2="13.3871" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6BB21"/>
<stop offset="1" stop-color="#F6C320"/>
</linearGradient>
<linearGradient id="paint11_linear_1_1002" x1="6.76292" y1="14.0426" x2="6.76292" y2="15.2826" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6C921"/>
<stop offset="1" stop-color="#F7D31F"/>
</linearGradient>
<linearGradient id="paint12_linear_1_1002" x1="10.3602" y1="11.7765" x2="10.3602" y2="13.0164" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6BB21"/>
<stop offset="1" stop-color="#F6C320"/>
</linearGradient>
<linearGradient id="paint13_linear_1_1002" x1="10.738" y1="13.672" x2="10.738" y2="14.912" gradientUnits="userSpaceOnUse">
<stop stop-color="#F6C921"/>
<stop offset="1" stop-color="#F7D31F"/>
</linearGradient>
</defs>
</svg>
